import { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
// import { useHistory } from "react-router-dom";
import { IEntityMinimalModel } from "../api/GenericTypes";
import { LucideIcon } from "../common/icon/LucideIcon";
import { DatasetFilters } from "../api/Datasets";
import { SplitDatePickerFormField } from "../common/formfields/DatePickerFormField/SplitDatePickerFormField";
import { SamplesVirtualizedSelectForm } from "../common/forms/EntityForms/formsVirtualized/SamplesVirtualizedSelectForm";

interface DatasetsFilterbarProps {
  setFilters: React.Dispatch<React.SetStateAction<DatasetFilters>>;
}

interface DatasetsFilterForm {
  operator?: IEntityMinimalModel[] | undefined | null;
  project?: IEntityMinimalModel[] | undefined | null;
  method?: IEntityMinimalModel[] | undefined | null;
  sample?: IEntityMinimalModel[] | undefined | null;
  creationDateFrom?: string | undefined | null;
  creationDateTo?: string | undefined | null;
}

export const SharedBundlesFilterBar = ({ setFilters }: DatasetsFilterbarProps) => {
  const { control, reset } = useForm<DatasetsFilterForm>({
    defaultValues: {},
  });
  const sample = useWatch({ name: "sample", control: control });
  const creationDateFrom = useWatch({ name: "creationDateFrom", control: control });
  const creationDateTo = useWatch({ name: "creationDateTo", control: control });

  useEffect(() => {
    setFilters((prevState) => ({
      ...prevState,
      sampleIds: Array.isArray(sample) && sample.length > 0 ? sample?.map((d) => d.id) : null,
    }));
  }, [sample, setFilters]);

  useEffect(() => {
    setFilters((prevState) => ({
      ...prevState,
      creationDateFrom: creationDateFrom ? new Date(creationDateFrom).toISOString() : null,
    }));
  }, [creationDateFrom, setFilters]);

  useEffect(() => {
    setFilters((prevState) => ({
      ...prevState,
      creationDateTo: creationDateTo ? new Date(creationDateTo).toISOString() : null,
    }));
  }, [creationDateTo, setFilters]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
      autoComplete="off"
    >
      <SamplesVirtualizedSelectForm id={"sample"} control={control} isMulti />

      <SplitDatePickerFormField
        control={control}
        idStart="creationDateFrom"
        idEnd="creationDateTo"
        label="Creation date (from - to)"
        horizontal={false}
        showTimeSelect
      />

      <hr />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn btn-ghost-secondary"
          onClick={(e) => {
            reset({
              project: null,
              operator: null,
              method: null,
              sample: null,
              creationDateFrom: null,
              creationDateTo: null,
            });
            e.preventDefault();
          }}
        >
          <LucideIcon name="refresh-cw" /> Reset filters
        </button>
      </div>
    </form>
  );
};
